/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* components */
import ConversionFlowVDP from './components/ConversionFlowVDP';

/* utilities */
import { parseDataToProps } from '~/utilities';

const conversionFlowVDPNodes = Array.from(document.querySelectorAll('.conversion-flow-vdp'));
[...conversionFlowVDPNodes].forEach((node) => render(<ConversionFlowVDP {...parseDataToProps(node.dataset)} />, node));
